import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { chairpersondata, NAV_LINK_LIST } from "../../../../utils/defaults";
import useOutsideClickHandler from "../../../../utils/outSideClickHandler";
import Cta from "../../ui/Cta";
import Paragraph from "../../ui/Paragraph";
import Icons from "../Icons";

const MobileView = ({ nav, onclick }) => {
  const [isDropOpen, setIsDropOpen] = useState(false);
  const [isSecondDropOpen, setIsSecondDropOpen] = useState(false); // 👈 new dropdown state

  const secondDropRef = useOutsideClickHandler(() =>
    setIsSecondDropOpen(false)
  ); // 👈 new dropdown ref
  useEffect(() => {
    if (isDropOpen) {
      setIsDropOpen(false);
    }
  }, [isSecondDropOpen]);
  useEffect(() => {
    if (isSecondDropOpen) {
      setIsDropOpen(false);
    }
  }, [isDropOpen]);
  return (
    <>
      <div
        className={`bg-[#EAE9F8] fixed top-0 z-50 shadow-common h-dvh pt-5 pb-10 md:pb-24 w-full overflow-auto hide-scrollbar ${
          !nav ? "translate-x-full -right-12" : "right-0"
        }`}
      >
        <div
          onClick={() => {
            onclick();
            setIsDropOpen(false);
          }}
          className="flex justify-end pr-5 sticky top-0 pb-1"
        >
          <Icons icon="drop-close" className="sm:size-9 cursor-pointer" />
        </div>
        {NAV_LINK_LIST.map((obj, index) => {
          return (
            index !== 1 && (
              <>
                <div
                  onClick={() => {
                    if (obj.list) {
                      setIsDropOpen(!isDropOpen);
                    } else {
                      onclick();
                    }
                  }}
                  key={index}
                  className={`sm:px-12 px-8 border-solid border-b border-b-custom-gray-v3 border-opacity-40 hover:bg-white`}
                >
                  <Link
                    to={obj.lsUrl || obj.url}
                    className="font-extrabold text-xl sm:text-2xl leading-[125%] py-6 flex justify-between items-center"
                  >
                    {obj.title}
                    {index === 2 && (
                      <Icons
                        className={`${
                          isDropOpen ? "rotate-180" : ""
                        } sm:w-7 w-6`}
                        pathClass="group-hover:fill-custom-black"
                        icon="DownArrowBold"
                      />
                    )}
                  </Link>{" "}
                  <div
                    className={`overflow-clip transition-all ease-linear duration-300 ${
                      isDropOpen ? "max-h-[200px]" : "max-h-0"
                    }`}
                  >
                    {obj.list &&
                      obj.list.map((list, listIndex) => (
                        <Link
                          key={listIndex}
                          to={`${list.url}`}
                          onClick={() => {
                            onclick();
                            setIsDropOpen(false);
                          }}
                        >
                          <Paragraph
                            className={`${
                              listIndex === 0 && "!mt-0"
                            } !leading-155 my-3.5 sm:my-5 !text-base sm:!text-xl`}
                            variant="off-gray"
                          >
                            {list.title}
                          </Paragraph>
                        </Link>
                      ))}
                  </div>
                </div>{" "}
                {index === 0 && (
                  <div
                    ref={secondDropRef}
                    className="relative hover:bg-white sm:px-12 px-8 border-solid border-b border-b-custom-gray-v3 border-opacity-40"
                  >
                    <button
                      onClick={() => setIsSecondDropOpen(!isSecondDropOpen)}
                      className={`font-extrabold text-xl sm:text-2xl leading-[125%] py-6 flex items-center gap-x-0.5 group w-full justify-between`}
                      title="open resources dropdown"
                    >
                      Chairperson
                      <Icons
                        className={`${
                          isSecondDropOpen ? "rotate-180" : ""
                        } sm:w-7 w-6`}
                        pathClass="group-hover:fill-custom-black"
                        icon="DownArrowBold"
                      />
                    </button>
                    <div
                      className={`overflow-clip transition-all ease-linear duration-300 ${
                        isSecondDropOpen ? "max-h-[400px] pb-5" : "max-h-[0px]"
                      }`}
                    >
                      {chairpersondata &&
                        chairpersondata.map((list, listIndex) => (
                          <Link
                            key={listIndex}
                            to={`${list.url}`}
                            onClick={() => {
                              onclick();
                              setIsDropOpen(false);
                            }}
                          >
                            <Paragraph
                              className={`${
                                listIndex === 0 && "mt-0"
                              } !leading-155 py-2 !text-base sm:!text-xl hover:text-[#241DB6]`}
                              variant={
                                list.url !== "" ? "dark-blue" : "off-gray"
                              }
                            >
                              {list.title}
                            </Paragraph>
                          </Link>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )
          );
        })}{" "}
        <div className="px-12 pt-12 text-center ">
          <span
            onClick={() => {
              onclick();
              setIsDropOpen(false);
            }}
          >
            <Cta href="/contact-us" className="sm:hidden w-full">
              Get A Quote
            </Cta>
          </span>
        </div>
      </div>
    </>
  );
};

export default MobileView;
